import { lazy, Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";

// SPEC-ActiveTask Phase A — the active detail lives on its OWN route
// (/qa/active/:id) and is a SEPARATE page from both the normal Delivery QA
// detail (qa-detail.tsx → qa-detail-v3) and the prescreen detail. Active mode
// is pinned by the route, never by a flag inside qa-detail-v3 (locked
// PreScreening separate-route rule).
const ActiveTaskDetailV3 = lazy(() => import("./activetask-detail-v3"));

export default function ActiveTaskDetail() {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-full">
          <Skeleton className="h-8 w-48" />
        </div>
      }
    >
      <ActiveTaskDetailV3 />
    </Suspense>
  );
}
